import React, { useState, useEffect } from 'react';
import './CookiePopup.css';
import { Cookie, X, Check } from 'lucide-react';

function CookiePopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState('main'); // 'main' | 'custom'
  const [preferences, setPreferences] = useState({ analytics: true, marketing: false });

  useEffect(() => {
    const consent = localStorage.getItem('crousradar_cookie_consent');
    if (!consent) {
      setTimeout(() => setIsOpen(true), 1500); // Popup logic
    }
  }, []);

  const saveConsent = (type) => {
    let finalPrefs = { analytics: false, marketing: false };
    if (type === 'all') finalPrefs = { analytics: true, marketing: true };
    else if (type === 'custom') finalPrefs = preferences;
    
    localStorage.setItem('crousradar_cookie_consent', JSON.stringify(finalPrefs));
    setIsOpen(false);
    setView('main');
  };

  if (!isOpen) {
    return (
      <button className="floating-cookie-btn" onClick={() => setIsOpen(true)} aria-label="Gérer les cookies">
        <Cookie size={24} color="var(--text-main)" />
      </button>
    );
  }

  return (
    <div className="cookie-wrapper">
      <div className="cookie-container">
        <button className="cookie-close" onClick={() => setIsOpen(false)} aria-label="Fermer">
          <X size={20} />
        </button>

        <div className="cookie-header">
          <div className="cookie-icon">
            <Cookie size={24} color="var(--primary)" />
          </div>
          <h3 className="cookie-title">
            {view === 'main' ? 'Votre vie privée' : 'Personnaliser'}
          </h3>
        </div>

        {view === 'main' ? (
          <>
            <p className="cookie-desc">
              Nous utilisons des cookies essentiels ainsi que des cookies d'analyse pour vous offrir la meilleure expérience.
            </p>
            <div className="cookie-actions-vertical">
              <button className="btn-brutal small primary" onClick={() => saveConsent('all')}>
                Tout accepter
              </button>
              <div className="cookie-actions-horizontal">
                <button className="btn-brutal small secondary" onClick={() => saveConsent('none')}>
                  Tout refuser
                </button>
                <button className="btn-brutal small outline" onClick={() => setView('custom')}>
                  Personnaliser
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="cookie-custom-view">
            <div className="cookie-option">
              <div className="cookie-op-text">
                <h4 id="cookie-essential-label">Essentiels</h4>
                <p>Nécessaires au fonctionnement du site.</p>
              </div>
              <div 
                className="toggle-switch disabled" 
                role="switch" 
                aria-checked="true" 
                aria-labelledby="cookie-essential-label"
                aria-disabled="true"
              >
                <div className="toggle-knob active"><Check size={10} color="var(--text-main)" strokeWidth={4}/></div>
              </div>
            </div>

            <div className="cookie-option">
              <div className="cookie-op-text">
                <h4 id="cookie-analytics-label">Analytics</h4>
                <p>Aide à mesurer anonymement notre audience.</p>
              </div>
              <div 
                className={`toggle-switch ${preferences.analytics ? 'active' : ''}`}
                onClick={() => setPreferences({...preferences, analytics: !preferences.analytics})}
                onKeyDown={(e) => { if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPreferences({...preferences, analytics: !preferences.analytics}); } }}
                role="switch"
                aria-checked={preferences.analytics}
                aria-labelledby="cookie-analytics-label"
                tabIndex="0"
              >
                <div className="toggle-knob"></div>
              </div>
            </div>

            <div className="cookie-option">
              <div className="cookie-op-text">
                <h4 id="cookie-marketing-label">Marketing</h4>
                <p>Pour des annonces personnalisées.</p>
              </div>
              <div 
                className={`toggle-switch ${preferences.marketing ? 'active' : ''}`}
                onClick={() => setPreferences({...preferences, marketing: !preferences.marketing})}
                onKeyDown={(e) => { if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPreferences({...preferences, marketing: !preferences.marketing}); } }}
                role="switch"
                aria-checked={preferences.marketing}
                aria-labelledby="cookie-marketing-label"
                tabIndex="0"
              >
                <div className="toggle-knob"></div>
              </div>
            </div>

            <button className="btn-brutal small primary full-w mt-4" onClick={() => saveConsent('custom')}>
              Enregistrer mes choix
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CookiePopup;
